import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import ApiClient from '../utils/ApiClient';

export default class FieldSuggestionApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('search'), options);
  }

  // =============================================================================
  //                          FIELD SUGGESTION SEARCH  APIs
  // =============================================================================

  public IndexFieldSuggestion(data: any) {
    const route = '/search/v1/fieldsuggestion/index';
    return this.post(route, data);
  }

  public GetFieldSuggestionList(data: any) {
    // Advanced search on field suggestion
    const route = '/search/v1/fieldsuggestion';
    return this.post(route, data);
  }
}
